
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/art",
      function () {
        return require("private-next-pages/art/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/art"])
      });
    }
  